/* AW Animation System — Scroll reveal & stagger engine */
(function () {
  'use strict';

  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var DURATION = '0.6s';

  /* ── Scroll reveal (data-aw-reveal) ───────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('[data-aw-reveal]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      /* Fallback for very old browsers: show immediately */
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-aw-delay') || '0', 10);
        if (delay > 0) {
          setTimeout(function () { el.classList.add('is-visible'); }, delay);
        } else {
          el.classList.add('is-visible');
        }
        observer.unobserve(el);
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ── Stagger children (data-aw-stagger) ───────────────────── */
  function initStagger() {
    var parents = document.querySelectorAll('[data-aw-stagger]');
    if (!parents.length) return;

    if (!('IntersectionObserver' in window)) {
      parents.forEach(function (parent) { parent.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var parent = entry.target;
        /* data-aw-stagger="80" → 80ms between each child (default 70) */
        var gap = parseInt(parent.getAttribute('data-aw-stagger') || '70', 10);
        if (isNaN(gap) || gap <= 0) gap = 70;

        Array.from(parent.children).forEach(function (child, i) {
          child.style.transitionDelay = (i * gap) + 'ms';
        });

        var parentDelay = parseInt(parent.getAttribute('data-aw-delay') || '0', 10);
        if (parentDelay > 0) {
          setTimeout(function () { parent.classList.add('is-visible'); }, parentDelay);
        } else {
          parent.classList.add('is-visible');
        }
        observer.unobserve(parent);
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -30px 0px'
    });

    parents.forEach(function (parent) { observer.observe(parent); });
  }

  /* ── Image reveal (class="aw-img-reveal") ─────────────────── */
  function initImageReveal() {
    document.querySelectorAll('img.aw-img-reveal').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load',  function () { img.classList.add('loaded'); }, { once: true });
        img.addEventListener('error', function () { img.classList.add('loaded'); }, { once: true });
      }
    });
  }

  /* ── Radio-style facet filters (data-aw-radio-group) ─────────
     When a checkbox is checked, automatically uncheck all other
     checkboxes inside the same fieldset[data-aw-radio-group].
     Uses capture phase so it runs BEFORE Dawn's change listener,
     ensuring the form state is correct when Dawn reads it.
  ────────────────────────────────────────────────────────────── */
  function initRadioFilters() {
    document.addEventListener('change', function (e) {
      var el = e.target;

      /* Only act on checkboxes that are being checked (not unchecked) */
      if (el.tagName !== 'INPUT' || el.type !== 'checkbox' || !el.checked) return;

      /* Must be inside a radio-group fieldset */
      var group = el.closest('[data-aw-radio-group]');
      if (!group) return;

      /* Uncheck every other checkbox in this group that shares the same name */
      group.querySelectorAll('input[type="checkbox"]').forEach(function (other) {
        if (other !== el && other.name === el.name && other.checked) {
          other.checked = false;
        }
      });
    }, true /* capture phase */);
  }

  /* ── Fluid-bg chain — fade gradient layers at section seams ──
     Detects adjacent .shopify-section elements that both contain
     .fluid-bg and adds CSS classes so gradient layers fade at the
     shared boundary instead of hard-clipping.
  ────────────────────────────────────────────────────────────── */
  function initFluidChain() {
    var sections = Array.from(document.querySelectorAll('.shopify-section'));

    /* Clear previously set classes (safe to call multiple times) */
    sections.forEach(function (s) {
      s.classList.remove('fluid-chain-fwd', 'fluid-chain-back');
    });

    for (var i = 0; i < sections.length - 1; i++) {
      var curr = sections[i];
      var next = sections[i + 1];
      if (curr.querySelector('.fluid-bg') && next.querySelector('.fluid-bg')) {
        curr.classList.add('fluid-chain-fwd');
        next.classList.add('fluid-chain-back');
      }
    }
  }

  /* ── Transparent hero header ──────────────────────────────── */
  function initTransparentHeader() {
    var header = document.querySelector('[data-aw-transparent]');
    if (!header) return;

    /* Đọc config từ data attributes */
    var threshold = parseInt(header.getAttribute('data-aw-threshold') || '80', 10);
    if (isNaN(threshold) || threshold < 0) threshold = 80;

    /* Đo chiều cao header → CSS var cho content offset */
    function setHeaderHeight() {
      document.documentElement.style.setProperty('--aw-header-h', header.offsetHeight + 'px');
    }
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(setHeaderHeight).observe(header);

    /* Section-header parent (cần transparent để không che content phía sau) */
    var sectionHeader = header.closest('.section-header') || header.parentElement;

    function applyTransparent(on) {
      if (on) {
        header.classList.add('aw-transparent');
        if (sectionHeader) sectionHeader.classList.add('aw-transparent-parent');
      } else {
        header.classList.remove('aw-transparent');
        if (sectionHeader) sectionHeader.classList.remove('aw-transparent-parent');
      }
    }

    var isSolid = false;
    var isHover = false;

    function update() {
      applyTransparent(!isSolid && !isHover);
    }

    /* Scroll */
    function onScroll() {
      isSolid = window.scrollY > threshold;
      update();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Hover */
    var hoverTimer = null;
    header.addEventListener('mouseenter', function () {
      clearTimeout(hoverTimer);
      isHover = true;
      update();
    });
    header.addEventListener('mouseleave', function () {
      hoverTimer = setTimeout(function () {
        isHover = false;
        update();
      }, 150);
    });

    /* Resize: re-check mobile */
    window.addEventListener('resize', update, { passive: true });
  }

  /* ── Bootstrap ────────────────────────────────────────────── */
  function init() {
    initRadioFilters();
    initTransparentHeader();
    initFluidChain();

    /* Skip animations if user prefers reduced motion */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    initReveal();
    initStagger();
    initImageReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run chain detection whenever the Shopify editor adds/removes a section */
  document.addEventListener('shopify:section:load',   function () { initFluidChain(); });
  document.addEventListener('shopify:section:unload', function () { initFluidChain(); });
}());
